import React, { useState } from 'react';
import { format, subMonths, startOfMonth, endOfMonth } from 'date-fns';
import { FaCalendarAlt } from 'react-icons/fa';
import { motion, AnimatePresence } from 'framer-motion';

const DateRangeSelector = ({ onDateRangeChange, currentRange }) => {
  const [isOpen, setIsOpen] = useState(false);
  
  const ranges = [
    { label: 'Past 3 Months', value: '3m', months: 3 },
    { label: 'Past 6 Months', value: '6m', months: 6 },
    { label: 'Past 12 Months', value: '12m', months: 12 },
    { label: 'Past 24 Months', value: '24m', months: 24 }
  ];

  // Find the current range value based on the label
  const selectedRange = ranges.find(range => range.label === currentRange.label)?.value || '12m';

  const handleRangeSelect = (range) => {
    const endDate = endOfMonth(new Date());
    // Start from beginning of this month minus (months-1)
    // This ensures we get complete months
    const startDate = startOfMonth(subMonths(new Date(), range.months - 1));
    
    onDateRangeChange({
      start: format(startDate, 'yyyy-MM-dd'),
      end: format(endDate, 'yyyy-MM-dd'),
      label: range.label
    });
    setIsOpen(false);
  };

  return (
    <div className="relative">
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="flex items-center space-x-2 px-3 py-2 bg-white dark:bg-gray-800 rounded-lg border border-gray-200 dark:border-gray-700 hover:bg-gray-50 dark:hover:bg-gray-700 transition-colors"
      >
        <FaCalendarAlt className="text-gray-500 dark:text-gray-400" />
        <span className="text-sm text-gray-700 dark:text-gray-300">
          {currentRange.label}
        </span>
      </button>

      <AnimatePresence>
        {isOpen && (
          <motion.div
            initial={{ opacity: 0, y: -10 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -10 }}
            className="absolute right-0 mt-2 w-48 bg-white dark:bg-gray-800 rounded-lg shadow-lg border border-gray-200 dark:border-gray-700 z-10"
          >
            {ranges.map((range) => (
              <button
                key={range.value}
                onClick={() => handleRangeSelect(range)}
                className={`w-full px-4 py-2 text-left text-sm transition-colors ${
                  selectedRange === range.value
                    ? 'bg-indigo-50 dark:bg-indigo-900/50 text-indigo-600 dark:text-indigo-400'
                    : 'text-gray-700 dark:text-gray-300 hover:bg-gray-50 dark:hover:bg-gray-700'
                }`}
              >
                {range.label}
              </button>
            ))}
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
};

export default DateRangeSelector; 